import { useContext } from 'react';
import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { i18n } from '../../../../../../common/i18n/i18n';
import { IconLogin, IconUser } from '../../../../../../common/images';
import Popup from '../../../../../../common/components/Popup/Popup';
import { AuthContext } from 'src/common/contexts/authContext';

const UserInfo = () => {
    const { user, logout } = useContext(AuthContext);

    return (
        <Popup
            actionElement={(handleOpen, anchorReference, isOpen) => (
                <Box
                    className={isOpen ? 'background-color-blst' : 'background-color-mho'}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        ml: 1,
                        mr: 1,
                        p: 1,
                        borderRadius: '61px',
                        cursor: 'pointer',
                    }}
                    onClick={(e) => {
                        handleOpen();
                    }}
                    ref={anchorReference}
                >
                    <IconUser fontSize="inherit" className={isOpen ? 'fill-b' : 'fill-md'} />
                </Box>
            )}
            contentElement={(handleClose) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', m: 1 }}>
                    <Box sx={{ display: 'flex', m: 1, alignItems: 'center' }}>
                        <Box
                            className="color-mh background-color-blst"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                p: 1,
                                mt: 1,
                                borderRadius: '61px',
                                height: 'fit-content',
                            }}
                        >
                            <IconUser fontSize="inherit" className="fill-md" />
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
                            <Typography variant="s14w700" className="color-bd">
                                {user.displayName}
                            </Typography>
                            <Typography className="color-md" sx={{ lineHeight: 1 }}>
                                {user.email}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider />

                    <List sx={{ mt: 1, mb: 1 }}>
                        <ListItem
                            disablePadding
                            onClick={(e) => {
                                logout();
                                handleClose();
                            }}
                        >
                            <ListItemButton
                                sx={{ height: '32px', minWidth: '186px', borderLeft: 'unset !important', p: 0 }}
                                className="background-color-hover-mho"
                            >
                                <ListItemIcon
                                    className="fill-md"
                                    sx={{
                                        justifyContent: 'center',
                                        minWidth: '40px',
                                    }}
                                >
                                    <IconLogin />
                                </ListItemIcon>
                                <ListItemText sx={{ pr: 1 }} primary={i18n.translate('Logout')} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            )}
        />
    );
};

export default UserInfo;
